import {NotificationService} from "@/services/ApiService";

const Notifications = {
  namespaced: true,
  state: {
    tenants: [],
    tenantsTree: [],
    channels: [],
    channelTypes: [],
    channelTypeTenants: [],
    subscriptionGroups: [],
    loadingData: true,
  },
  getters: {
    getTenants: (state) => state.tenants,
    getTenantsTree: (state) => state.tenantsTree,
    getChannels: (state) => state.channels,
    getChannelTypes: (state) => state.channelTypes,
    getChannelTypeTenants: (state) => state.channelTypeTenants,
    getSubscriptionGroups: (state) => state.subscriptionGroups,
    isLoadingData: (state) => state.loadingData,
  },
  mutations: {
    setTenants(state, payload) {
      state.tenants = payload;
    },
    setTenantsTree(state, payload) {
      state.tenantsTree = payload;
    },
    setChannels(state, payload) {
      state.channels = payload;
    },
    setChannelTypes(state, payload) {
      state.channelTypes = payload;
    },
    setChannelTypeTenants(state, payload) {
      state.channelTypeTenants = payload;
    },
    setSubscriptionGroups(state, payload) {
      state.subscriptionGroups = payload;
    },
    setLoadingData(state, payload) {
      state.loadingData = payload;
    }
  },
  actions: {
    async prepareData({commit}) {
      await commit("setLoadingData", true);
      const tenantsListRaw = await (await NotificationService.Tenants.get()).data;
      const channelTypesListRaw = await (await NotificationService.Channels.getTypes()).data;
      const channelsListRaw = await (await NotificationService.Channels.get()).data;
      const channelTypeTenantListRaw = await (await NotificationService.Channels.getTenantChannels()).data;
      const subscriptionGroupListRaw = await (await NotificationService.NotificationGroups.get()).data;

      /* CHANNEL TYPES */
      commit("setChannelTypes", channelTypesListRaw);

      /* SORTED TENANTS alphanumerical */
      const sortedTenantsAlpha = tenantsListRaw.sort(function (a, b) {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      // commit("setTenants", sortedTenantsAlpha);

      /* REFINED CHANNEL TYPE TENANTS */
      const refinedChannelTypeTenantsList = channelTypeTenantListRaw.map(channelTypeTenantItem => {
        const tenant = {
          id: '',
          name: '',
          parent: '',
        };
        const channel = {
          id: '',
          name: '',
          label: '',
          description: '',
          specifications: {},
        };
        tenantsListRaw.forEach(tenantItem => {
          if (tenantItem.id === channelTypeTenantItem.tenant_id) {
            tenant.id = tenantItem.id;
            tenant.name = tenantItem.name;
            tenant.parent = tenantItem.parent;
          }
        });
        channelTypesListRaw.forEach(channelTypeItem => {
          if (channelTypeItem.id === channelTypeTenantItem.channelTypeId) {
            channel.id = channelTypeItem.id;
            channel.name = channelTypeItem.name;
            channel.label = channelTypeItem.label;
            channel.description = channelTypeItem.description;
            channel.specifications = channelTypeItem.specifications;
          }
        });
        return {
          ...channelTypeTenantItem,
          channel,
          tenant
        };
      });
      commit('setChannelTypeTenants', refinedChannelTypeTenantsList);

      /* REFINED CHANNELS LIST*/
      const refinedChannelsList = channelsListRaw.map(channelItem => {
        let tenant = {
          id: '',
          name: '',
          parent: '',
        };
        let channelType = {
          id: '',
          name: '',
          label: '',
          description: '',
          specifications: {},
        };
        let channelData = {};
        refinedChannelTypeTenantsList.forEach(augmentedChannelTypeTenantItem => {
          if (augmentedChannelTypeTenantItem.id === channelItem.channelTypeTenant) {
            tenant = {...augmentedChannelTypeTenantItem.tenant};
          }
          if (channelItem.channelTypeTenant === augmentedChannelTypeTenantItem.id) {
            channelData = augmentedChannelTypeTenantItem.channel;
          }
        });
        channelTypesListRaw.forEach(channelTypeItem => {
          if (channelItem.channelMessageType === channelTypeItem.name) {
            channelType = {...channelTypeItem};
          }
        });
        return {...channelItem, channel: channelData, channelType, tenant};
      });
      commit("setChannels", refinedChannelsList);

      /* TENANTS */
      const augmentedTenantsList = sortedTenantsAlpha.map(tenantItem => {
        let channels = [];
        let subscribers = [];
        // console.log('refinedChannelTypeTenantsList', refinedChannelTypeTenantsList);
        refinedChannelTypeTenantsList.forEach(refinedChannelTypeTenantItem => {
          if (tenantItem.id === refinedChannelTypeTenantItem.tenant_id) {
            channels.push(refinedChannelTypeTenantItem.channel);
          }
          refinedChannelsList.forEach(channelItem => {
            if (
                (channelItem.channelTypeTenant === refinedChannelTypeTenantItem.id) &&
                (channelItem.channel.id === refinedChannelTypeTenantItem.channelTypeId) &&
                (tenantItem.id === refinedChannelTypeTenantItem.tenant_id)
            ) {
              // let channelData = {...channelItem};
              // console.log('channelItem TO AUGMENTED TENANT', channelItem);
              subscribers.push(channelItem);
            }
          });
        });
        // console.log('subscribers', subscribers);
        return {
          ...tenantItem,
          channels,
          subscribers
        };
      });

      augmentedTenantsList.forEach(tenantItem => {
        if (tenantItem.subscribers && tenantItem.subscribers.length > 0) {
          tenantItem.subscribers.sort((a, b) => {
            // First compare by channel message type
            const channelType = a.channelMessageType.localeCompare(b.channelMessageType);
            if (channelType !== 0) {
              return channelType;
            }

            // If channel message types are the same, then compare by description
            const sortA = a.description;
            const sortB = b.description;
            return sortA - sortB;
          });
        }
      });
      // console.log('augmentedTenantsList', augmentedTenantsList);
      commit("setTenants", augmentedTenantsList);

      /* SUBSCRIPTION GROUPS */
      const refinedSubscriptionGroupsList = subscriptionGroupListRaw.map(subscriptionGroupItem => {
        let tenant = {};
        augmentedTenantsList.forEach(tenantItem => {
          if (subscriptionGroupItem.owner === tenantItem.id) {
            tenant = {...tenantItem};
          }
        });
        return {...subscriptionGroupItem, tenant};
      });
      commit("setSubscriptionGroups", refinedSubscriptionGroupsList);
      await commit("setLoadingData", false);
    },

    async constructTenantsTree({commit, state}) {
      await commit("setLoadingData", true);
      const tenantsArray = state.tenants.map(tenantItem => ({...tenantItem, children: []}));

      /**
       * Recursive function to nest Tenants to their corresponding parent tenants
       *
       * @param tenants {Array} the updated tenants array on current recursion
       * @param parent {String} the 'parent' ID of the tenant to nest under
       * @returns {*} an updated tenants list with refined parent tenant for each recursion
       */
      function buildTree(tenants, parent = null) {
        return tenants
            .filter(tenantItem => tenantItem.parent === parent)
            .map(filteredTenantItem => ({
              ...filteredTenantItem,
              children: buildTree(tenants, filteredTenantItem.id)
            }));
      }


      const structuredTenantsArray = buildTree(tenantsArray);
      // console.log('structuredTenantsArray');
      // console.log(structuredTenantsArray);
      function sortItemsRecursively(items) {
        // First, sort the current array of items based on the "name" property
        items.sort((a, b) => a.name.localeCompare(b.name));

        // Now, recursively sort any nested "children" arrays
        items.forEach(item => {
          if (item.children && item.children.length > 0) {
            sortItemsRecursively(item.children);
          }
        });
      }

      sortItemsRecursively(structuredTenantsArray);
      // this.tenantsTree = structuredTenantsArray;
      await commit("setTenantsTree", structuredTenantsArray);
      await commit("setLoadingData", false);
    }
  }
};

export default Notifications;